// Host-side IndexedDB helper for the embedded terrain editor.
//
// React fetches terrain + element JSON from the API and writes one dataset
// record here; the iframed tool reads it back via public/heatmap-tool/idb-source.js.
// Both sides MUST keep the same DB name/version/stores.
//   DB "igolf-heatmap" v1
//   store "datasets" keyPath "key" -> { key, stem, step, id_course, id_courseInt, terrain, elements }
//   store "edits"    keyPath "key" -> { key, name, text }

const DB_NAME = "igolf-heatmap";
const DB_VERSION = 1;

function openDb() {
	return new Promise((resolve, reject) => {
		const req = indexedDB.open(DB_NAME, DB_VERSION);
		req.onupgradeneeded = () => {
			const db = req.result;
			if (!db.objectStoreNames.contains("datasets"))
				db.createObjectStore("datasets", { keyPath: "key" });
			if (!db.objectStoreNames.contains("edits"))
				db.createObjectStore("edits", { keyPath: "key" });
		};
		req.onsuccess = () => resolve(req.result);
		req.onerror = () => reject(req.error);
	});
}

// Build the dataset key the tool loads via ?key=
export const datasetKey = (id_course, step) => `${id_course}_${step}`;

export async function putDataset(record) {
	const db = await openDb();
	return new Promise((resolve, reject) => {
		const tx = db.transaction("datasets", "readwrite");
		tx.objectStore("datasets").put(record);
		tx.oncomplete = () => resolve();
		tx.onerror = () => reject(tx.error);
	});
}

export async function getEdited(key) {
	const db = await openDb();
	return new Promise((resolve, reject) => {
		const tx = db.transaction("edits", "readonly");
		const r = tx.objectStore("edits").get(key);
		r.onsuccess = () => resolve(r.result || null);
		r.onerror = () => reject(r.error);
	});
}
